// extracted by mini-css-extract-plugin
export var icon = "_68-1";
export var subtext = "_68-0";